(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storeCaptainDetailsForm', [ '$Teams', '$firebaseArray', '$templateCache', '$timeout', '$compile', '$http', function ($Teams, $firebaseArray, $templateCache, $timeout, $compile, $http) {

		return {
			templateUrl: 'directives/storeCaptainDetailsForm/form.html',
			scope: {
				store: '='
			},
            controller: function($scope) {

                // console.log('scope', $scope);
                // console.log('store', $scope.store);

                $scope.sendURLs = () => {

                    let scope = angular.extend($scope.$new(), {
                        store: $scope.store,
                        storeUrl: location.protocol + '//' + location.host + '/#/storefront/' + $scope.store.$id,
                        orderUrl: location.protocol + '//' + location.host + '/#/teamorder/' + $scope.store.$id

                    });

                    let template = $templateCache.get('directives/storeCaptainDetailsForm/captainStoreURLsEmail.html');

                    // console.log('template -> ', template);

                    let el = $compile(template)(scope);


                    // var queryString = {
                    //   emailTo: $scope.store.captain.email,
                    //   emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                    //   subject: $scope.store.team + ' » ' + $scope.store.name + ' Store Links',
                    //   message: el.html()
                    // }

                    // console.log('query string', queryString)

                    $timeout(function(){

                        var queryString = $.param({
                          emailTo: $scope.store.captain.email,
                          emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                          subject: $scope.store.team + ' » ' + $scope.store.name + ' Store Links',
                          message: el[0].innerHTML
                        })

                        // $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer', queryString).then( (response) => {
                        $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+queryString).then( (response) => {

                            alert('URLs email sent.');

                        }, (errorResponse) => {

                            console.log('send email -> errorResponse', errorResponse);

                            alert('There was an issue in trying to send URLs.');

                        });

                    }, 1000);

                }

				// $scope.teamList = $Teams.all();

			}
		};

	}]);

})();
